<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="经销商搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入经销商名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="addAgentOpenBtn('')">添加经销商</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="dealerName"
            label="经销商名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            label="账号（手机号）">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="addAgentOpenBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 添加经销商弹窗 -->
    <el-dialog
      :title="infoId == '' ? '添加经销商' : '编辑经销商'"
      :visible.sync="addAgentShow"
      width="960px">
      <el-form :model="oneForm" label-width="140px">
        <el-form-item label="经销商名称：" prop="dealerName">
          <el-input style="width: 420px;" v-model="oneForm.dealerName" placeholder="请输入经销商名称"></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="mobile">
          <el-input style="width: 420px;" v-model="oneForm.mobile" placeholder="请输入登录账号"></el-input>
        </el-form-item>
        <el-form-item v-if="infoId == ''" label="密码：" prop="password">
          <el-input type="password" show-password style="width: 420px;" v-model="oneForm.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="oneForm.status"
            active-color="#13ce66"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { queryDealerAccountPageList, removeDealerAccountById, enableOrDisableDealerAccount, saveDealerAccount, updateDealerAccount, fetchDealerAccountDetailById } from '@/api/distributor'
export default {
  name: 'AgentManagement',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 添加经销商弹窗
      addAgentShow:false,
      infoId:'',
      oneForm:{
        dealerName:'',
        mobile:'',
        password:'',
        status:false
      },
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryDealerAccountPageList({ dealerName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableOrDisableDealerAccount({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {

              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 添加额外签到积分弹窗-打开弹窗操作 */
    addAgentOpenBtn (infoId) {
      this.oneForm.dealerName = '';
      this.oneForm.mobile = '';
      this.oneForm.password = '';
      this.oneForm.status = false;
      this.infoId = infoId;
      let that = this
      if(infoId == ''){
        that.addAgentShow = true;
      }else{
        fetchDealerAccountDetailById({ id: infoId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.oneForm.dealerName = data.dealerName;
            that.oneForm.mobile = data.mobile;
            that.oneForm.password = data.password;
            that.oneForm.status = data.status == 1 ? true : false;
            that.addAgentShow = true;
          }else{
            that.$message.error(res.msg);
          }
        })
      }
    },
    // 添加额外签到积分弹窗-保存操作
    saveBtn(){
      var that = this
      var infoId = that.infoId
      var dealerName = that.oneForm.dealerName
      var mobile = that.oneForm.mobile
      var password = that.oneForm.password
      let status = that.oneForm.status ? 1 : 0
      if (dealerName === '') {
        this.$message.error('请输入经销商名称')
        return false
      }
      if (mobile === '') {
        this.$message.error('请输入登录账号')
        return false
      }
      if (password === '' && infoId == '') {
        this.$message.error('请输入登录密码')
        return false
      }
      let passData = {
        dealerName: dealerName, mobile: mobile, password: password, status:status
      }
      that.fullscreenLoading = true;
      if(infoId == ''){
        saveDealerAccount(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        passData.id = infoId;
        passData.password = '';
        updateDealerAccount(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false;
      if(res.errorCode == "0000"){
        that.$message.success(res.msg);
        that.oneForm.dealerName = '';
        that.oneForm.mobile = '';
        that.oneForm.password = '';
        that.oneForm.status = false;
        that.addAgentShow = false;
        that.getInfoList();
      }
      if(res.errorCode == "1001"){
        that.$message.error(res.msg);
      }
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeDealerAccountById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/distributor/AgentManagement.vue